module.exports = __webpack_public_path__ + "static/media/Headshot.1d232da4.jpg";